import type { FaireProductEntity } from "../../entity_types/product";

export const p_dy3ssbdyc5: FaireProductEntity = {
  token: "p_dy3ssbdyc5",
  type: "product",
  name: "Calendula & Clay Bath Soak",
  brandToken: "b_qgbeutab83",
  brandName: "Merigold",
  imageUrl:
    "https://cdn.faire.com/fastly/ca4610cf8237270732b130ff296a9c69c02ce42a783d6b5f11cbf950679fe1a8.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/480e3565999fa8d70268d418cf014ef75ecd7451aefb334d4bf8bc35fcf5ced5.jpeg",
    "https://cdn.faire.com/fastly/d3a4fe98e66d09d5adb2a322de47f595cbd3ab172b2c005556c37dda46b3278a.jpeg",
    "https://cdn.faire.com/fastly/9819afb3601f306e71b4f8a95eb4956460c25ca17c3fce625e4b7ef9d539682b.jpeg",
    "https://cdn.faire.com/fastly/dcf4f32c89a3b486b8f9d07749a42a8c1db52c3299c0b29807db83527d092544.jpeg",
    "https://cdn.faire.com/fastly/a3c1a1173afb6753de1956418322a92a03d3685d94a73c630bd5e79be78d1dd7.jpeg",
    "https://cdn.faire.com/fastly/006c776e90be8a659cd1aaa707663503494fe766233aaf6cf78712c4d35b0df4.jpeg",
    "https://cdn.faire.com/fastly/9f377927d534c20d227b6bf52ae0d648fc00ddc4a1455294813e0e463cb2cb7c.jpeg",
  ],
  priceDollars: 9.5,
  description:
    "Soften into stillness with our Calendula Clay Bath Soak—a thoughtful blend of mineral-rich salts, soothing botanicals, and natural clay, designed to nourish both body and spirit.\n\n• Magnesium flakes and Epsom salt are known for their mineral content and are often used in baths to encourage relaxation and ease feelings of tension.\n• Organic calendula is cherished for its calming properties and has been traditionally used to soothe and nurture skin.\n• French green clay is valued for its ability to gently draw out impurities, helping to leave skin feeling renewed and balanced.\n\nThis bath is more than a soak—it’s an intentional ritual to nourish your skin, relax your body, and create space for stillness.",
  tags: [],
  msrpDollars: 19,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:54:12.132Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
